export const translations = {
  fr: {
    // Common
    'footer.disclaimer': 'Les r&eacute;ponses de l\'IA peuvent parfois contenir des erreurs.',
    'chat.popular.questions.title': 'Questions fr&eacute;quentes', // Fixed encoding
    'dialog.new.conversation.title': 'Nouvelle Conversation',
    'dialog.new.conversation.description': '&Ecirc;tes-vous s&ucirc;r de vouloir commencer une nouvelle conversation ? Cela effacera l&#x27;historique actuel.',
    'dialog.new.conversation.confirm': 'Nouvelle Conversation',
    'dialog.cancel': 'Annuler',
    'popup.recent.response.title': 'Derni&egrave;re r&eacute;ponse IA',
    'popup.copy': 'Copier',
    'popup.no.response': 'Aucune r&eacute;ponse IA r&eacute;cente trouv&eacute;e',
    'toast.conversation.copied': 'Conversation copi&eacute;e dans le presse-papiers',
    'toast.conversation.copy.error': '&Eacute;chec de la copie de la conversation',
    'toast.no.conversation': 'Aucune conversation &agrave; copier',
    'toast.response.copied': 'R&eacute;ponse copi&eacute;e dans le presse-papiers',
    'toast.copy.error': '&Eacute;chec de la copie',
    'toast.new.conversation.started': 'Une nouvelle conversation d&eacute;bute!',
    'language.french': 'FR',
    'language.english': 'EN',
    'language.change': 'Changer de langue',
    'notfound.title': 'Page non trouv&eacute;e',
    'notfound.description': 'La page que vous recherchez n&#x27;existe pas.',
    'notfound.home': 'Retour &agrave; l&#x27;accueil',
    'inventory.title': 'Inventaire par cat&eacute;gorie',
    'inventory.vehicles.available': 'v&eacute;hicules disponibles',
    'inventory.modelsInInventory': 'Mod&egrave;les en inventaire',
    'inventory.modelInInventory': 'Mod&egrave;le en inventaire',

    // Hours
    'hours.service': 'Heures du Service',
    'hours.appointment': 'Heures de rendez-vous',
    'promotions.aftersale.title': 'Voir nos promotions apr&egrave;s-vente',
    
    // Promotion types
    'promotions.type.aftersale': 'Service apr&egrave;s-vente',
    'promotions.type.financing': 'Financement',
    'promotions.type.leasing': 'Location',
    'promotions.type.oemOffer': 'Offre du Manufacturier!',
    'promotions.type.zeroFinancing': 'Financement &agrave; 0%!',
    'promotions.type.dealer': 'Offre du concessionnaire',
    'promotions.type.oemRebates': 'Rabais du manufacturier',
    'promotions.type.other': 'Autre',
    
    // Promotion actions
    'promotions.more': 'Plus',
    'promotions.less': 'Moins',
    'promotions.view': 'Voir promotion',
    'promotions.description': 'Description',

    // Chat Interface
    'chat.welcome.title': 'Bienvenue!',
    'chat.welcome.subtitle': 'Votre partenaire automobile de confiance',
    'chat.welcome.greeting': 'Bonjour et bienvenue!',
    
    // Classification results
    'classification.quick.results': 'Parfait! Pendant que je pr&eacute;pare la r&eacute;ponse parfaite, voici ce que j&#x27;ai pu trouver rapidement pour vous pour commencer!',
    'chat.welcome.intro': 'Je suis votre chatbot IA. Demandez-moi n&#x27;importe quoi!',
    'chat.agent.name': 'Agent IA',
    'chat.agent.connected': 'Assistant IA connect&eacute;',
    'chat.agent.disconnected': 'L&#x27;IA n&#x27;est pas disponible actuellement',
    'chat.agent.status': 'En ligne et pr&ecirc;t &agrave; aider',
    'chat.agent.searching': 'recherche...',
    'chat.agent.thinking': 'r&eacute;fl&eacute;chit...',
    'chat.agent.typing': 'tape...',
    'chat.agent.step1': '&Eacute;tape 1: R&eacute;flexion',
    'chat.agent.step2': '&Eacute;tape 2: Collecte de donn&eacute;es',
    'chat.agent.step3': '&Eacute;tape 3: Cr&eacute;ation de la r&eacute;ponse',
    'chat.you': 'Vous',
    'chat.typing': 'Agent IA &eacute;crit...',
    'chat.input.placeholder': 'Tapez votre message...',
    'chat.input.placeholder.welcome': 'Tapez votre message...',
    'chat.input.hint': 'Demandez-moi n&#x27;importe quoi...',
    'chat.input.transcribing': 'Transcription en cours...',
    'chat.input.listening': 'J&#x27;&eacute;coute',
    'chat.input.recording': 'Enregistrement en cours...',
    'chat.input.start.recording': 'Commencer l&#x27;enregistrement',
    'chat.input.stop.recording': 'Arr&ecirc;ter l&#x27;enregistrement',
    'chat.input.dictate.tooltip': 'Dictez-moi n&#x27;importe quelle question en main libre !',
    'chat.input.speech.tooltip': 'Discutons de vive-voix !',
    'chat.input.send': 'Envoyer',
    'chat.watermark': '&#x26A1; D2C Media Chatbot Boost',
    'chat.copy.conversation': 'Copie de la conversation',
    'chat.new.conversation': 'Commencer une nouvelle conversation',
    'chat.collapse': 'R&eacute;duire',
    'chat.closeChat': 'Fermer le chat',
    'chat.expand': 'Ouvrir le chat',
    'chat.button.suv': 'Je cherche un VUS blanc &agrave; moins de 50K km',
    'chat.button.cheapest.suvs': 'Affiche tes 5 VUS les moins chers',
    'chat.button.appointment': 'Je veux prendre un rendez-vous',
    'chat.button.vehicles.by.color': 'Combien de v&eacute;hicules avez-vous par couleur?',
    'chat.button.best.price.sorento': 'Quel est votre meilleur prix sur ce Sorento 2021!',
    'chat.similar.models': 'Voir notre inventaire',
    'chat.view.more': 'Voir Plus',
    'chat.view.similar.models': 'Voir notre inventaire',
    'chat.see.video': 'Voir vidéo',
    'chat.maps.get.directions': 'Obtenir l&#x27;itin&eacute;raire',
    'chat.maps.open': 'Ouvrir dans Google Maps',
    'chat.maps.address.unavailable': 'Adresse non disponible',
    'chat.error.retry.message': 'Je suis d&eacute;sol&eacute;, cela a pris beaucoup plus de temps que pr&eacute;vu. Voulez-vous que je r&eacute;essaie ?',
    'chat.error.retry.button': 'OK R&eacute;essayer',
    'chat.loadingMore': 'Chargement...',

    // Popular Questions
    'chat.test.prompt.suv.electric': 'Envoyez-moi votre SUV hybride blanc le moins cher.',
    'chat.test.prompt.certified.suv.black': 'Je cherche un VUS certifi&eacute; noir &agrave; moins de 60K$.',
    'chat.test.prompt.suvs.fuel': 'Combien avez-vous de nouveaux VUS en stock par couleur',
    'chat.test.prompt.configure.seltos': 'Je veux configurer mon nouveau Seltos.',
    'chat.test.prompt.k4.videos': 'Avez-vous des vid&eacute;os K4 &agrave; partager ?',
    'chat.test.prompt.try.ev9': 'Je veux essayer un nouveau EV9.',
    'chat.test.prompt.service.appointment': 'J&#x27;ai besoin d&#x27;un rendez-vous de service.',
    'chat.test.prompt.trade.rav4': 'Combien pouvez-vous m&#x27;offrir pour mon Rav4 2020 ?',
    'chat.test.prompt.closing.hours': '&Agrave; quelle heure fermez-vous aujourd&#x27;hui ?',
    'chat.test.prompt.weekend.hours': '&Ecirc;tes-vous ouvert cette fin de semaine ?',
    'chat.test.prompt.test.drive.crv': 'Puis-je faire un essai routier d&#x27;un CR-V 2021 ce vendredi apr&egrave;s-midi ?',
    'chat.test.prompt.sportage.automatic': 'Le Kia Sportage 2023 est-il automatique ?',
    'chat.test.prompt.f150.availability': 'Votre site ne semble pas avoir de F-150 2023-24 sous 20Km, n&#x27;est-ce pas ?',
    'chat.test.prompt.antitheft.name': 'Quel est le nom de l&#x27;antivol que je dois installer sur ma nouvelle voiture ?',
    'chat.test.prompt.job.search': 'Je cherche un emploi.',
    'chat.test.prompt.kia.promotions.month': 'Kia a-t-il de bonnes promotions ce mois-ci ?',
    'chat.test.prompt.service.promos': 'Avez-vous des promos de service ?',
    'chat.test.prompt.suv.homescreen': 'Je cherche un VUS blanc &agrave; moins de 50K km',
    'chat.test.prompt.cheapest.suvs.homescreen': 'Affiche tes 5 VUS les moins chers',
    'chat.test.prompt.appointment.homescreen': 'Je veux prendre un rendez-vous',
    'chat.test.prompt.vehicles.by.color.homescreen': 'Combien de v&eacute;hicules avez-vous par couleur?',

    // Chat appointment messages
    'chat.appointment.sales.message': 'Super! Simplement remplir le formulaire de rendez-vous ci-bas!',
    'chat.appointment.service.message': 'Parfait! Remplissez le formulaire de rendez-vous au service ci-dessous et nous vous contacterons sous peu pour confirmer!',

    // Forms
    'form.name': 'Nom complet',
    'form.email': 'Courriel',
    'form.phone': 'T&eacute;l&eacute;phone',
    'form.question_interest': 'Question / Int&eacute;r&ecirc;t',
    'form.question_interest_placeholder': 'D&eacute;crivez votre question ou int&eacute;r&ecirc;t...',
    'form.message': 'Message',
    'form.submit': 'Soumettre',
    'form.close': 'Fermer',
    'form.next': 'Suivant',
    'form.back': 'Retour',
    'form.dateOfBirth': 'Date de naissance',
    'form.annualIncome': 'Revenu annuel brut',
    'form.address': 'Adresse',
    'form.vehicleOfInterest': 'V&eacute;hicule d&#39;int&eacute;r&ecirc;t',
    'form.vehicleOfInterestPlaceholder': 'Quel v&eacute;hicule souhaitez-vous financer?',
    'form.monthlyBudget': 'Budget mensuel',
    'form.appointmentDate': 'Date du rendez-vous',
    'form.appointmentTime': 'Heure',
    'form.selectTime': 'S&eacute;lectionnez',
    'form.serviceDate': 'Date de pr&eacute;f&eacute;rence du rendez-vous',
    'form.serviceTime': 'Heure',
    'form.interest': 'Int&eacute;r&ecirc;t',
    'form.timeSlot.early': 'T&ocirc;t',
    'form.timeSlot.late': 'Tard',
    'form.timeSlot.specificTime': '*une heure pr&eacute;cise vous sera confirm&eacute;e',
    'form.selectDate': 'Choisir une date',
    'form.appointment.submitted': 'Demande de rendez-vous soumise',
    'form.service.submitted': 'Demande de service soumise',
    'form.carfax.submitted': 'Demande Carfax soumise',
    'form.contact.submitted': 'Demande de contact soumise',
    'form.finance.submitted': 'Demande de financement soumise',
    'form.offer.submitted': 'Demande d&#x27;offre soumise',
    'form.trade.submitted': 'Demande d&#x27;&eacute;change soumise',
    'form.addressPlaceholder': 'Commencez &agrave; taper votre adresse...',
    'form.addressHint': 'Commencez &agrave; taper pour voir les suggestions',
    'form.contactTitle': 'Informations de contact',
    'form.financeTitle': 'Soyez pr&eacute;-approuv&eacute; maintenant!',
    'form.tradeTitle': 'Informations d&#x27;&eacute;change',
    'form.serviceTitle': 'Prenez votre rendez-vous au service ici!',
    'form.offerTitle': 'D&eacute;couvrez notre offre par SMS!',
    'form.appointmentTitle': 'Prenez un rendez-vous aux ventes ici!',
    'form.defaultTitle': 'Formulaire',
    'form.notImplemented': 'Le formulaire "{formType}" n&#x27;est pas encore impl&eacute;ment&eacute;.',
    'form.expandForm': 'D&eacute;velopper le formulaire',
    'form.collapseForm': 'R&eacute;duire le formulaire',
    'form.closeForm': 'Fermer le formulaire',
    'form.carfaxTitle': 'Recevez le Carfax sans frais par texto!',
    'form.fullName': 'Nom complet',
    'form.mobile': 'Mobile (SMS)',
    'form.submitting': 'Envoi...',
    'chat.download.conversation': 'T&eacute;l&eacute;charger la conversation',
    'form.finance.title': 'Soyez pr&eacute;-approuv&eacute; maintenant!',
    'form.contact.title': 'Des questions pour un sp&eacute;cialiste?',
    'form.offer.title': 'D&eacute;couvrez notre offre par SMS!',
    'form.appointment.title': 'Prenez un rendez-vous aux ventes ici!',
    'form.service.title': 'Prenez votre rendez-vous au service ici!',
    'form.carfax.title': 'Recevez le Carfax sans frais par texto!',
    'form.trade.title': 'Informations d&#x27;&eacute;change',
    'form.tradev2.title': 'Prenez un RDV d&#x27;&eacute;valuation gratuit!',
    'form.default.title': 'Formulaire',
    'form.default.content': 'Contenu du formulaire non disponible',
    'form.submission.success': 'Merci, un sp&eacute;cialiste vous contactera sous peu!',
    'form.toast.success.default': 'Merci! Nous vous contacterons sous peu!',
    'form.toast.success.contact': 'Merci! Un sp&eacute;cialiste vous contactera sous peu!',
    'form.toast.success.finance': 'Merci! Un conseiller financier vous contactera sous peu!',
    'form.toast.success.appointment': 'Merci! Nous confirmerons votre rendez-vous sous peu!',
    'form.toast.success.service': 'Merci! Nous confirmerons votre rendez-vous de service sous peu!',
    'form.toast.success.offer': 'Merci! Vous recevrez notre offre par SMS sous peu!',
    'form.toast.success.carfax': 'Merci! Vous recevrez le rapport Carfax par SMS sous peu!',
    'form.toast.success.trade': 'Merci! Un &eacute;valuateur vous contactera sous peu!',

    // Form validation
    'form.validation.mandatoryFields': 'Veuillez remplir tous les champs obligatoires',
    'form.validation.dateRequired': 'La date de naissance est requise',
    'form.validation.dateFormat': 'Veuillez entrer une date valide au format AAAA-MM-JJ',
    'form.validation.dateInvalid': 'Veuillez entrer une date valide',
    'form.validation.dateFuture': 'La date de naissance ne peut pas &ecirc;tre dans le futur',
    'form.validation.ageMinimum': 'Vous devez avoir au moins {age} ans',
    'form.validation.dateIncomplete': 'Veuillez compl&eacute;ter la date',
    'form.validation.ageRequirement': 'Doit avoir 18 ans et plus',

    // Trade Estimate
    'trade.estimate.title': 'Valeur d&#x27;&eacute;change en 30sec!',
    'trade.estimate.start': 'Commencer maintenant',
    'trade.estimate.free': 'Estim&eacute; d&#x27;&eacute;change gratuit',
    'trade.vehicle.info': 'Parlez-nous de votre v&eacute;hicule',
    'trade.vehicle.details': 'D&eacute;tails du v&eacute;hicule',
    'trade.contact.info': 'Informations de contact',
    'trade.vin.label': 'Num&eacute;ro VIN (17 caract&egrave;res)',
    'trade.year.make.model': 'Ann&eacute;e-Marque-Mod&egrave;le',
    'trade.year': 'Ann&eacute;e',
    'trade.make': 'Marque',
    'trade.model': 'Mod&egrave;le',
    'trade.trim': 'Finition (optionnel)',
    'trade.color': 'Couleur',
    'trade.mileage': 'Kilom&eacute;trage',
    'trade.accidented': 'V&eacute;hicule accident&eacute;?',
    'trade.yes': 'Oui',
    'trade.no': 'Non',
    'trade.insurance.claim': 'Montant de la r&eacute;clamation d&#x27;assurance',
    'trade.get.estimate': 'Obtenir l&#x27;estimation',
    'trade.submitting': 'Envoi...',

    // Service Form
    'service.form.external.message': 'Cliquez ici pour acc&eacute;der &agrave; notre formulaire rapide de prise de rendez-vous au service en ligne :',
    'service.form.external.button': 'Formulaire de service',

    // Vehicle Card
    'vehicle.starting.at': '&Agrave; partir de',
    'vehicle.view.details': 'Voir les d&eacute;tails',
    'vehicle.description': 'Description',
    'vehicle.year': 'Ann&eacute;e',
    'vehicle.make': 'Marque',
    'vehicle.model': 'Mod&egrave;le',
    'vehicle.trim': 'Version',
    'vehicle.color': 'Couleur',
    'vehicle.mileage': 'Kilom&eacute;trage',
    
    // Fuel types
    'fuel.electric': 'Électrique',
    'fuel.hybrid': 'Hybride',
    'fuel.phev': 'PHEV',
    'fuel.plugin': 'PHEV',
    'fuel.gas': 'Essence',
    'fuel.gasoline': 'Essence',
    'fuel.diesel': 'Diesel',
    
    // Colors
    'color.black': 'Noir',
    'color.white': 'Blanc',
    'color.grey': 'Gris',
    'color.gray': 'Gris',
    'color.blue': 'Bleu',
    'color.red': 'Rouge',
    'color.green': 'Vert',
    'color.yellow': 'Jaune',
    'color.orange': 'Orange',
    'color.silver': 'Argent',
    'color.gold': 'Or',
    'color.brown': 'Brun',
    'color.beige': 'Beige',
    'color.tan': 'Beige',
    'color.purple': 'Violet',
    'color.mauve': 'Mauve',
    'color.copper': 'Cuivre',
    'vehicle.stock': 'Stock #',
    'vehicle.features': 'Plus',
    'vehicle.details': 'Plus',
    'vehicle.highlights': 'Points saillants',
    'vehicle.more': 'Plus',
    'vehicle.view': 'Voir',
    'vehicle.location': 'Emplacement',
    'vehicle.carfax': 'Carfax',
    'vehicle.carfax.report': 'Rapport CARFAX',
    'vehicle.discover.offer': 'D&eacute;couvrez l&#x27;offre!',
    'vehicle.picture.coming.soon': 'Photo &agrave; venir!',
    'vehicle.price.not.available': 'Prix non disponible',
    'vehicle.mileage.not.available': 'Kilom&eacute;trage non disponible',

    // Prompt Menu
    'promptMenu.searching': 'Je recherche...',
    'promptMenu.reset': 'Recommencer',
    'promptMenu.readyToSend': 'Pr&ecirc;t &agrave; envoyer votre message',

    // Vehicle Interest Dropdown
    'vehicle.interest.title': 'Vous avez montr&eacute; l&#x27;int&eacute;r&ecirc;t suivant',
    'vehicle.interest.loading': 'Chargement...',
    'vehicle.interest.time': 'Heure',
    'vehicle.interest.interest': 'Int&eacute;r&ecirc;t',
    'vehicle.interest.count': 'Nombre',
    'vehicle.interest.source': 'Source',
    
    // Opening Hours
    'hours.closed': 'Ferm&eacute;',
    
    // System messages
    'system.waking.up': 'R&eacute;veil en cours...',
    'system.refreshing.connection': 'Actualisation de la connexion apr&egrave;s inactivit&eacute;',
    'system.connection.restored': 'Connexion restaur&eacute;e',
    'system.recovery.failed': '&Eacute;chec de la r&eacute;cup&eacute;ration',
    'system.please.refresh': 'Veuillez actualiser la page si les probl&egrave;mes persistent',
    
    // Error messages
    'error.connection.recovered': 'J&#x27;ai rencontr&eacute; un probl&egrave;me de connexion mais j&#x27;ai r&eacute;cup&eacute;r&eacute;. Veuillez r&eacute;essayer votre message.',
    'error.technical.difficulties': 'Je rencontre actuellement des difficult&eacute;s techniques. Veuillez r&eacute;essayer dans un moment. Erreur :',
    'error.form.submission.failed': 'La soumission du formulaire a &eacute;chou&eacute;. Veuillez r&eacute;essayer.',
    'error.audio.transcription.failed': '&Eacute;chec de la transcription audio. Veuillez r&eacute;essayer.',
    'error.ai.configuration.issue': 'Je m&#x27;excuse, mais je ne peux actuellement pas fournir de r&eacute;ponses IA en raison d&#x27;un probl&egrave;me de configuration. Notre &eacute;quipe a &eacute;t&eacute; notifi&eacute;e et r&eacute;soudra cela sous peu. En attendant, vous pouvez toujours utiliser les formulaires et autres fonctionnalit&eacute;s de ce site Web.',
    'error.edge.function.failed': '&Eacute;chec de l&#x27;envoi d&#x27;une requ&ecirc;te &agrave; la fonction Edge',
    
    // Speech-to-speech mode
    'speech.connecting': 'Connexion...',
    'speech.listening': '&Eacute;coute en cours...',
    'speech.speaking': 'R&eacute;ponse en cours...',
    'speech.ready': 'Pr&ecirc;t - parlez maintenant',
    'speech.you': 'Vous',
    'speech.assistant': 'Assistant',
    'speech.tapToEnd': 'Appuyez sur le bouton pour terminer la conversation',
    'speech.tapToStart': 'Appuyez pour d&eacute;marrer la conversation vocale',
    
    // Copy conversation
    'copyConversation.loading': 'Copie de votre conversation...',
  },
  en: {
    // Common
    'footer.disclaimer': 'AI responses may include errors.',
    'chat.popular.questions.title': 'Popular Questions',
    'dialog.new.conversation.title': 'New Conversation',
    'dialog.new.conversation.description': 'Are you sure you want to start a new conversation? This will clear the current history.',
    'dialog.new.conversation.confirm': 'New Conversation',
    'dialog.cancel': 'Cancel',
    'popup.recent.response.title': 'Latest AI Response',
    'popup.copy': 'Copy',
    'popup.no.response': 'No recent AI response found',
    'toast.conversation.copied': 'Conversation copied to clipboard',
    'toast.conversation.copy.error': 'Failed to copy conversation',
    'toast.no.conversation': 'No conversation to copy',
    'toast.response.copied': 'Response copied to clipboard',
    'toast.copy.error': 'Failed to copy',
    'toast.new.conversation.started': 'New conversation started!',
    'language.french': 'FR',
    'language.english': 'EN',
    'language.change': 'Change language',
    'notfound.title': 'Page Not Found',
    'notfound.description': 'The page you are looking for does not exist.',
    'notfound.home': 'Back to Home',
    'inventory.title': 'Inventory count',
    'inventory.vehicles.available': 'vehicles available',
    'inventory.modelsInInventory': 'In-stock models',
    'inventory.modelInInventory': 'In-stock model',

    // Hours
    'hours.service': 'Service Hours',
    'hours.appointment': 'Appointment Hours',
    'promotions.aftersale.title': 'See our Aftersale Promotions',
    
    // Promotion types
    'promotions.type.aftersale': 'Aftersale',
    'promotions.type.financing': 'Financing',
    'promotions.type.leasing': 'Leasing',
    'promotions.type.oemOffer': 'OEM Offer!',
    'promotions.type.zeroFinancing': '0% Financing!',
    'promotions.type.dealer': 'Dealer Offer',
    'promotions.type.oemRebates': 'OEM Rebates',
    'promotions.type.other': 'Other',
    
    // Promotion actions
    'promotions.more': 'More',
    'promotions.less': 'Less',
    'promotions.view': 'View promotion',
    'promotions.description': 'Description',

    // Chat Interface
    'chat.welcome.title': 'Welcome!',
    'chat.welcome.subtitle': 'Your trusted automotive partner',
    'chat.welcome.greeting': 'Hello and welcome!',
    
    // Classification results
    'classification.quick.results': 'Perfect! While I craft the perfect answer, here\'s what I could find real quickly for you to start with!',
    'chat.welcome.intro': 'I\'m your AI chatbot. Ask me anything!',
    'chat.agent.name': 'AI Agent',
    'chat.agent.connected': 'AI Assistant Connected',
    'chat.agent.disconnected': 'AI currently unavailable',
    'chat.agent.status': 'Online and ready to help',
    'chat.agent.searching': 'is now searching...',
    'chat.agent.thinking': 'is now thinking...',
    'chat.agent.typing': 'is now typing...',
    'chat.agent.step1': 'Step 1: Thinking',
    'chat.agent.step2': 'Step 2: Gathering Data',
    'chat.agent.step3': 'Step 3: Crafting Answer',
    'chat.you': 'You',
    'chat.typing': 'AI Agent is typing...',
    'chat.input.placeholder': 'Write your message...',
    'chat.input.placeholder.welcome': 'Ask me anything!',
    'chat.input.hint': 'Ask me anything...',
    'chat.input.transcribing': 'Transcribing...',
    'chat.input.listening': 'I\'m listening',
    'chat.input.recording': 'Recording...',
    'chat.input.start.recording': 'Start recording',
    'chat.input.stop.recording': 'Stop recording',
    'chat.input.dictate.tooltip': 'Click here to easily dictate your message!',
    'chat.input.speech.tooltip': 'Let\'s talk live!',
    'chat.input.send': 'Send',
    'chat.watermark': '⚡ D2C Media Chatbot Boost',
    'chat.copy.conversation': 'Copy conversation',
    'chat.new.conversation': 'Start new conversation',
    'chat.collapse': 'Collapse',
    'chat.closeChat': 'Close Chat',
    'chat.expand': 'Open chat',
    'chat.button.suv': 'I\'m looking for a black SUV under $60K',
    'chat.button.cheapest.suvs': 'List me your top-5 cheapest SUV\'s',
    'chat.button.appointment': 'I want to book an appointment',
    'chat.button.vehicles.by.color': 'How many vehicles do you have by color?',
    'chat.button.best.price.sorento': 'What is your best price on this 2021 Sorento!',
    'chat.similar.models': 'View our inventory',
    'chat.view.more': 'View more',
    'chat.view.similar.models': 'View our inventory',
    'chat.see.video': 'See video',
    'chat.maps.get.directions': 'Get Directions',
    'chat.maps.open': 'Open in Google Maps',
    'chat.maps.address.unavailable': 'Address not available',
    'chat.error.retry.message': 'I\'m sorry, this took way longer than it should have. Let me try one more time.',
    'chat.error.retry.button': 'OK Try Again',
    'chat.loadingMore': 'Loading...',

    // Popular Questions
    'chat.test.prompt.suv.electric': 'Show me your cheapest white hybrid SUV.',
    'chat.test.prompt.certified.suv.black': 'Looking for a certified black SUV under $50K.',
    'chat.test.prompt.suvs.fuel': 'How many new SUV\'s do you have in stock by color',
    'chat.test.prompt.configure.seltos': 'I want to configure my new Seltos.',
    'chat.test.prompt.k4.videos': 'Do you have K4 videos to share?',
    'chat.test.prompt.try.ev9': 'I want to try a new EV9.',
    'chat.test.prompt.service.appointment': 'I need a service appointment.',
    'chat.test.prompt.trade.rav4': 'How much can you offer me for my 2020 Rav4?',
    'chat.test.prompt.closing.hours': 'What time do you close today?',
    'chat.test.prompt.weekend.hours': 'Are you open this weekend?',
    'chat.test.prompt.test.drive.crv': 'Can I test drive a 2021 CR-V this Friday afternoon?',
    'chat.test.prompt.sportage.automatic': 'Is the Kia Sportage 2023 automatic?',
    'chat.test.prompt.f150.availability': 'Your site doesn\'t seem to have a 2023-24 F-150 under 20Km, right?',
    'chat.test.prompt.antitheft.name': 'What is the name of the anti-theft I need to install on my new car?',
    'chat.test.prompt.job.search': 'Looking for a job.',
    'chat.test.prompt.kia.promotions.month': 'Does Kia have any good promotions this month?',
    'chat.test.prompt.service.promos': 'Do you have any service promos?',
    'chat.test.prompt.suv.homescreen': 'I\'m looking for a black SUV under $60K',
    'chat.test.prompt.cheapest.suvs.homescreen': 'Show me your top-5 cheapest SUV\'s',
    'chat.test.prompt.appointment.homescreen': 'I want to book an appointment',
    'chat.test.prompt.vehicles.by.color.homescreen': 'How many vehicles do you have by color?',

    // Chat appointment messages
    'chat.appointment.sales.message': 'Awesome! Simply fill out the sales appointment form below!',
    'chat.appointment.service.message': "Perfect! Fill out the service appointment form below and we'll contact you shortly to confirm!",

    // Forms
    'form.name': 'Full Name',
    'form.email': 'Email',
    'form.phone': 'Phone',
    'form.question_interest': 'Question / Interest',
    'form.question_interest_placeholder': 'Describe your question or interest...',
    'form.message': 'Message',
    'form.submit': 'Submit',
    'form.close': 'Close',
    'form.next': 'Next',
    'form.back': 'Back',
    'form.dateOfBirth': 'Date of Birth',
    'form.annualIncome': 'Annual Income',
    'form.address': 'Address',
    'form.vehicleOfInterest': 'Vehicle of Interest',
    'form.vehicleOfInterestPlaceholder': 'What vehicle are you looking to finance?',
    'form.monthlyBudget': 'Monthly Budget',
    'form.appointmentDate': 'Appointment Date',
    'form.appointmentTime': 'Time',
    'form.selectTime': 'Select',
    'form.serviceDate': 'Preferred Appointment Date',
    'form.serviceTime': 'Time',
    'form.interest': 'Interest',
    'form.timeSlot.early': 'Early',
    'form.timeSlot.late': 'Late',
    'form.timeSlot.specificTime': '*a specific time will be confirmed',
    'form.selectDate': 'Choose a date',
    'form.appointment.submitted': 'Appointment request submitted',
    'form.service.submitted': 'Service request submitted',
    'form.carfax.submitted': 'Carfax request submitted',
    'form.contact.submitted': 'Contact request submitted',
    'form.finance.submitted': 'Finance request submitted',
    'form.offer.submitted': 'Offer request submitted',
    'form.trade.submitted': 'Trade request submitted',
    'form.addressPlaceholder': 'Start typing your address...',
    'form.addressHint': 'Start typing to see suggestions',
    'form.contactTitle': 'Contact Information',
    'form.financeTitle': 'Get Pre-Approved Now!',
    'form.tradeTitle': 'Trade Information',
    'form.serviceTitle': 'Book your Service Appointment here!',
    'form.offerTitle': 'Discover our Offer by SMS now!',
    'form.appointmentTitle': 'Book a Sales Appointment here!',
    'form.defaultTitle': 'Form',
    'form.notImplemented': 'The "{formType}" form is not yet implemented.',
    'form.expandForm': 'Expand form',
    'form.collapseForm': 'Collapse form',
    'form.closeForm': 'Close form',
    'form.carfaxTitle': 'Get your free Carfax report by SMS!',
    'form.fullName': 'Full Name',
    'form.mobile': 'Mobile (SMS)',
    'form.submitting': 'Submitting...',
    'chat.download.conversation': 'Download conversation',
    'form.finance.title': 'Get Pre-Approved Now!',
    'form.contact.title': 'Questions for one of our specialists?',
    'form.offer.title': 'Discover our Offer by SMS now!',
    'form.appointment.title': 'Book a Sales Appointment here!',
    'form.service.title': 'Book your Service Appointment here!',
    'form.carfax.title': 'Get your free Carfax report by SMS!',
    'form.trade.title': 'Trade Information',
    'form.tradev2.title': 'Book a free in-person appraisal!',
    'form.default.title': 'Form',
    'form.default.content': 'Form content not available',
    'form.submission.success': 'Thanks, a specialist will contact you shortly!',
    'form.toast.success.default': 'Thanks! We\'ll contact you shortly!',
    'form.toast.success.contact': 'Thanks! A specialist will contact you shortly!',
    'form.toast.success.finance': 'Thanks! A finance advisor will contact you shortly!',
    'form.toast.success.appointment': 'Thanks! We\'ll confirm your appointment shortly!',
    'form.toast.success.service': 'Thanks! We\'ll confirm your service appointment shortly!',
    'form.toast.success.offer': 'Thanks! You\'ll receive our offer by SMS shortly!',
    'form.toast.success.carfax': 'Thanks! You\'ll receive the Carfax report by SMS shortly!',
    'form.toast.success.trade': 'Thanks! An appraiser will contact you shortly!',

    // Form validation
    'form.validation.mandatoryFields': 'Please fill out all mandatory fields',
    'form.validation.dateRequired': 'Date of birth is required',
    'form.validation.dateFormat': 'Please enter a valid date in YYYY-MM-DD format',
    'form.validation.dateInvalid': 'Please enter a valid date',
    'form.validation.dateFuture': 'Date of birth cannot be in the future',
    'form.validation.ageMinimum': 'You must be at least {age} years old',
    'form.validation.dateIncomplete': 'Please complete the date',
    'form.validation.ageRequirement': 'Must be 18+ years old',

    // Trade Estimate
    'trade.estimate.title': 'Free trade estimate in 30sec!',
    'trade.estimate.start': 'Start now',
    'trade.estimate.free': 'Free Trade Estimate',
    'trade.vehicle.info': 'Tell us about your trade',
    'trade.vehicle.details': 'Vehicle Details',
    'trade.contact.info': 'Contact Information',
    'trade.vin.label': 'VIN Number (17 characters)',
    'trade.year.make.model': 'Year-Make-Model',
    'trade.year': 'Year',
    'trade.make': 'Make',
    'trade.model': 'Model',
    'trade.trim': 'Trim (optional)',
    'trade.color': 'Color',
    'trade.mileage': 'Mileage',
    'trade.accidented': 'Vehicle accidented?',
    'trade.yes': 'Yes',
    'trade.no': 'No',
    'trade.insurance.claim': 'Insurance claim amount',
    'trade.get.estimate': 'Get Estimate',
    'trade.submitting': 'Submitting...',

    // Service Form
    'service.form.external.message': 'Click here to access our quick online service booking form:',
    'service.form.external.button': 'Service Form',

    // Vehicle Card
    'vehicle.starting.at': 'Starting at',
    'vehicle.view.details': 'View Details',
    'vehicle.description': 'Description',
    'vehicle.year': 'Year',
    'vehicle.make': 'Make',
    'vehicle.model': 'Model',
    'vehicle.trim': 'Trim',
    'vehicle.color': 'Color',
    'vehicle.mileage': 'Mileage',
    
    // Fuel types
    'fuel.electric': 'Electric',
    'fuel.hybrid': 'Hybrid',
    'fuel.phev': 'PHEV',
    'fuel.plugin': 'PHEV',
    'fuel.gas': 'Gas',
    'fuel.gasoline': 'Gasoline',
    'fuel.diesel': 'Diesel',
    
    // Colors  
    'color.black': 'Black',
    'color.white': 'White',
    'color.grey': 'Grey',
    'color.gray': 'Gray',
    'color.blue': 'Blue',
    'color.red': 'Red',
    'color.green': 'Green',
    'color.yellow': 'Yellow',
    'color.orange': 'Orange',
    'color.silver': 'Silver',
    'color.gold': 'Gold',
    'color.brown': 'Brown',
    'color.beige': 'Beige',
    'color.tan': 'Tan',
    'color.purple': 'Purple',
    'color.mauve': 'Mauve',
    'color.copper': 'Copper',
    'vehicle.stock': 'Stock #',
    'vehicle.features': 'More',
    'vehicle.details': 'More',
    'vehicle.highlights': 'Highlights',
    'vehicle.more': 'More',
    'vehicle.view': 'View',
    'vehicle.location': 'Location',
    'vehicle.carfax': 'Carfax',
    'vehicle.carfax.report': 'CARFAX Report',
    'vehicle.discover.offer': 'Discover offer!',
    'vehicle.picture.coming.soon': 'Picture coming soon!',
    'vehicle.price.not.available': 'Price not available',
    'vehicle.mileage.not.available': 'Mileage not available',
    
    // Prompt Menu
    'promptMenu.searching': 'I\'m looking for...',
    'promptMenu.reset': 'Reset',
    'promptMenu.readyToSend': 'Ready to send your message',
    
    // Vehicle Interest Dropdown
    'vehicle.interest.title': 'You\'ve shown the following interest',
    'vehicle.interest.loading': 'Loading...',
    'vehicle.interest.time': 'Time',
    'vehicle.interest.interest': 'Interest',
    'vehicle.interest.count': 'Count',
    'vehicle.interest.source': 'Source',
    
    // Opening Hours
    'hours.closed': 'Closed',
    
    // System messages
    'system.waking.up': 'Waking up...',
    'system.refreshing.connection': 'Refreshing connection after inactivity',
    'system.connection.restored': 'Connection restored',
    'system.recovery.failed': 'Recovery failed',
    'system.please.refresh': 'Please refresh the page if issues persist',
    
    // Error messages
    'error.connection.recovered': 'I encountered a connection issue but have recovered. Please try your message again.',
    'error.technical.difficulties': 'I\'m experiencing some technical difficulties right now. Please try again in a moment. Error:',
    'error.form.submission.failed': 'Form submission failed. Please try again.',
    'error.audio.transcription.failed': 'Failed to transcribe audio. Please try again.',
    'error.ai.configuration.issue': 'I apologize, but I\'m currently unable to provide AI responses due to a configuration issue. Our team has been notified and will resolve this shortly. In the meantime, you can still use the forms and other features of this website.',
    'error.edge.function.failed': 'Failed to send a request to the Edge Function',
    
    // Speech-to-speech mode
    'speech.connecting': 'Connecting...',
    'speech.listening': 'Listening...',
    'speech.speaking': 'Speaking...',
    'speech.ready': 'Ready - speak now',
    'speech.you': 'You',
    'speech.assistant': 'Assistant',
    'speech.tapToEnd': 'Tap the button to end the conversation',
    'speech.tapToStart': 'Tap to start voice conversation',
    
    // Copy conversation
    'copyConversation.loading': 'Copying your conversation...',
  }
};

export type TranslationKey = keyof typeof translations.fr;